import type { CalendarEvent, CalendarGroup } from '../types.js';

export function eventInstanceKey(event: CalendarEvent): string {
  if (typeof event.occurrenceId === 'string' && event.occurrenceId.length > 0) {
    return event.occurrenceId;
  }
  return `${event.id}:${event.startsAt}:${event.endsAt ?? ''}`;
}

export function uniqueCalendarEvents(
  events: readonly CalendarEvent[],
): readonly CalendarEvent[] {
  const seen = new Set<string>();
  const out: CalendarEvent[] = [];
  for (const event of events) {
    const key = eventInstanceKey(event);
    if (seen.has(key)) continue;
    seen.add(key);
    out.push(event);
  }
  return out;
}

export function uniqueCalendarGroups(
  groups: readonly CalendarGroup[],
): readonly CalendarGroup[] {
  const seen = new Set<string>();
  const out: CalendarGroup[] = [];
  for (const group of groups) {
    if (seen.has(group.id)) continue;
    seen.add(group.id);
    out.push(group);
  }
  return out;
}
